import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const links = [
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Skills', href: '#skills' },
  { label: 'Experience', href: '#experience' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <>
      <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
          padding: '1rem 3rem',
          background: scrolled ? 'rgba(6,8,15,0.7)' : 'transparent',
          backdropFilter: scrolled ? 'blur(24px) saturate(160%)' : 'none',
          WebkitBackdropFilter: scrolled ? 'blur(24px) saturate(160%)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : 'none',
          transition: 'all 0.4s ease',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}
      >
        <a href="#home" style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontSize: '1.1rem', fontWeight: 700,
          background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          backgroundClip: 'text', textDecoration: 'none',
        }}>
          aryan.dev
        </a>

        <nav className="hidden md:flex" style={{ alignItems: 'center', gap: '2.2rem', display: 'flex' }}>
          {links.map(link => (
            <a key={link.href} href={link.href} style={{
              fontFamily: 'Inter, sans-serif', fontSize: '0.85rem',
              color: 'rgba(240,246,255,0.55)', textDecoration: 'none',
              transition: 'color 0.2s',
            }}
              onMouseEnter={e => (e.currentTarget.style.color = '#f0f6ff')}
              onMouseLeave={e => (e.currentTarget.style.color = 'rgba(240,246,255,0.55)')}
            >
              {link.label}
            </a>
          ))}
          <a href="/Aryan-Pandey-cv.pdf" target="_blank" rel="noopener noreferrer"
            className="glass-btn-outline glass-btn"
            style={{ padding: '0.45rem 1.2rem', borderRadius: '10px', fontSize: '0.82rem' }}
          >
            Resume ↗
          </a>
        </nav>

        <button onClick={() => setMenuOpen(v => !v)} className="md:hidden"
          style={{ background: 'none', border: 'none', display: 'flex', flexDirection: 'column', gap: '5px', padding: '0.4rem' }}>
          {[0, 1, 2].map(i => (
            <motion.span key={i}
              animate={{ rotate: menuOpen && i === 0 ? 45 : menuOpen && i === 2 ? -45 : 0, opacity: menuOpen && i === 1 ? 0 : 1, y: menuOpen && i === 0 ? 7 : menuOpen && i === 2 ? -7 : 0 }}
              transition={{ duration: 0.25 }}
              style={{ display: 'block', width: 22, height: 1.5, background: '#f0f6ff', borderRadius: 2 }}
            />
          ))}
        </button>
      </motion.header>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              position: 'fixed', inset: 0, zIndex: 190,
              background: 'rgba(6,8,15,0.95)', backdropFilter: 'blur(32px)',
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', gap: '2.5rem',
            }}
          >
            {links.map((link, i) => (
              <motion.a key={link.href} href={link.href} onClick={() => setMenuOpen(false)}
                initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.07 }}
                style={{
                  fontFamily: 'Space Grotesk, sans-serif', fontSize: '2.2rem',
                  fontWeight: 700, color: '#f0f6ff', textDecoration: 'none',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'linear-gradient(135deg,#3b82f6,#8b5cf6)'; e.currentTarget.style.WebkitBackgroundClip = 'text'; e.currentTarget.style.WebkitTextFillColor = 'transparent'; }}
                onMouseLeave={e => { e.currentTarget.style.WebkitTextFillColor = '#f0f6ff'; e.currentTarget.style.background = 'none'; }}
              >
                {link.label}
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
